//import { useThemeVariable } from '@ublique/components/Theme'

const useColorTheme = (t) => {
  const colorTheme = {
    ripristini: '#0043CE',
    immissioni: '#0F62FE',
    dismissioni: '#9F1853',
    trasferiti: '#F1C21B',
    immRipristino: '#0043CE',
    immObbligatori: '#0F62FE',
    immDataDifferenziata: '#4589FF',
    immPull: '#78A9FF',
    immPush: '#A6C8FF',
    dismPush: '#9F1853',
    dismPull: '#D12771'
  }

  return colorTheme
}

export default useColorTheme
